import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const FixedLayoutIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FixedLayout",
    children: /*#__PURE__*/_jsx("path", {
      d: "M10.24 5.52c-.2-.2-.06-.55.23-.55h16.08a3.24 3.24 0 0 1 3.24 3.24v15.74c0 .67-.41.75-.87.25l-1.74-1.74a.56.56 0 0 1-.17-.4v-5.97h-6.12c-.05 0-.1-.02-.14-.06l-2.37-2.38a.197.197 0 0 1 .14-.34h8.5V8.22c0-.26-.21-.46-.46-.46h-9.72v3.75c0 .22-.27.34-.43.18l-2.28-2.28s-.07-.11-.07-.18V7.76h-1.21a.87.87 0 0 1-.62-.26l-1.98-1.98Zm9.58 19.07a.56.56 0 0 0-.4-.17h-2.61v-2.6c0-.16-.06-.32-.18-.43l-2.19-2.19c-.15-.15-.41-.04-.41.17v5.05H5.25c-.26 0-.46-.21-.46-.46V9.65c0-.1-.05-.2-.12-.27L2.75 7.46c-.18-.18-.35-.39-.55-.39-.24 0-.2.68-.2 1.15v15.76a3.24 3.24 0 0 0 3.24 3.22h16.52c.25 0 .37-.3.2-.47l-2.13-2.14Zm9.66 2.4L5.14 2.61c-.39-.39-1.44-1.03-2.42-.05-.85.85-.46 2-.04 2.42l24.35 24.47a1.703 1.703 0 0 0 2.45 0 1.702 1.702 0 0 0 0-2.45Z"
    })
  }));
};